<template>
	<div class="contained-section flex h-full items-center bg-[#1C458A]">
		<div>
			<IconIdriveRentalLogo />
			<h4 class="mt-8 text-2xl text-white">
				Looking for short term rental?
			</h4>
			<p class="text-white">
				We have got you covered. Head over to our sister company,
				iDriveRentals. They will take good care of you.
			</p>
			<div class="mt-8">
				<CarbarLink
					href="https://www.idriverentals.com.au/?utm=cbref"
					target="_blank"
					:underline="false"
				>
					<CarbarButton :is-full-width="false">
						Check out iDriveRentals
					</CarbarButton>
				</CarbarLink>
			</div>
		</div>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import IconIdriveRentalLogo from '@/assets/svg/logo-idriveRentals.svg'
</script>
